export default __webpack_public_path__ + "static/media/compras.b6f419bc.png";